// import React, { useState } from "react";

// import Lightbox from "react-awesome-lightbox";
// import "react-awesome-lightbox/build/style.css";

// export const FieldActivities = ({subProjectData}) => {
//   const [largeImage, setLargeImg] = useState(false);
//   const [imageShow, setImageshow] = useState("");
//   return (
//       <div className="p-0">
//         <div className="field-activities-container">
//           <div className="image-grid">
//            {subProjectData?.map((img, index) => (
//   <div className="image-card" key={index}>
//     {img.type?.includes("image")?
//     <img
//       src={img.url}
//       alt={`Field ${index + 1}`}
//       className="cursor-pointer"
//       onClick={() => {
//         setLargeImg(true);
//         setImageshow(img.url);
//       }}
//     />
//     :
//      <video
//             src={img.url || img.preview}
//             width="100%"
//             height="100%"
//             controls
//             className="rounded"
//           />
//     }
//   </div>
// ))}
//    {largeImage && (
//               <Lightbox
//                 image={imageShow}
//                 title="Image Title"
//                 onClose={() => setLargeImg(false)}
//               />
//             )}
//           </div>
//           {subProjectData?.length===0&&  <div
//               style={{
//                 textAlign: "center",
//                 padding: "50px 20px",
//                 color: "#666",
//                 fontSize: "18px",
//                 fontWeight: "500",
//                 background: "#fafafa",
//                 borderRadius: "8px",
//                 border: "1px dashed #ccc",
//               }}
//             >
//               🚜 No activities found yet.
//               <p style={{ fontSize: "14px", marginTop: "8px", color: "#888" }}>
//                 Please check back later for updates.
//               </p>
//             </div>
//         }
//         </div>

//       </div>
//   );
// };

import React, { useState } from "react";

import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";

export const FieldActivities = ({ subProjectData }) => {
  const [largeImage, setLargeImg] = useState(false);
  const [imageShow, setImageshow] = useState("");

  return (
    <div className="p-0">
      <div className="field-activities-container">
        {subProjectData?.length > 0 ? (
          <div className="image-grid">
            {subProjectData.map((img, index) => (
              <div className="image-card" key={index}>
                {img.type?.includes("image") ? (
                  <img
                    src={img.url}
                    alt={`Field ${index + 1}`}
                    className="cursor-pointer"
                    loading="lazy"
                    onClick={() => {
                      setLargeImg(true);
                      setImageshow(img.url);
                    }}
                  />
                ) : (
                  <video
                    src={img.url || img.preview}
                    width="100%"
                    height="100%"
                    controls
                    preload="none"
                    className="rounded"
                  />
                )}
              </div>
            ))}
            {largeImage && (
              <Lightbox
                image={imageShow}
                title="Image Title"
                onClose={() => setLargeImg(false)}
              />
            )}
          </div>
        ) : (
          <div className="no-activities">
            🚜 No activities found yet.
            <p>Please check back later for updates.</p>
          </div>
        )}
      </div>

      <style jsx>{`
        .image-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
          gap: 12px;
        }
        .image-card {
          width: 100%;
          overflow: hidden;
          border-radius: 8px;
        }
        .image-card img,
        .image-card video {
          width: 100%;
          height: auto;
          object-fit: cover;
          border-radius: 8px;
        }
        .no-activities {
          text-align: center;
          padding: 50px 20px;
          color: #666;
          font-size: 18px;
          font-weight: 500;
          background: #fafafa;
          border-radius: 8px;
          border: 1px dashed #ccc;
        }
        .no-activities p {
          font-size: 14px;
          margin-top: 8px;
          color: #888;
        }

        @media (max-width: 768px) {
          .image-grid {
            grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
            gap: 10px;
          }
        }

        @media (max-width: 480px) {
          .image-grid {
            grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
            gap: 8px;
          }
        }
      `}</style>
    </div>
  );
};
